import React from 'react';
import { Radio, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IJournalResponseInput } from '../../../../global/entities/Journal/Journal';

interface SimpleYesNoQuestionProps {
    questionId: number;
    response: IJournalResponseInput | undefined;
    onResponseChange: (questionId: number, updates: Partial<IJournalResponseInput>) => void;
    readOnly?: boolean;
}

export const SimpleYesNoQuestion: React.FC<SimpleYesNoQuestionProps> = ({
    questionId,
    response,
    onResponseChange,
    readOnly = false
}) => {
    const { t } = useTranslation();

    // Normalize the response value to lowercase to match radio button values
    const normalizedValue = response?.responseValue?.toLowerCase() || '';

    return (
        <Radio.Group
            value={normalizedValue}
            onChange={readOnly ? undefined : (value) => onResponseChange(questionId, { responseValue: value })}
        >
            <Group gap="md">
                <Radio 
                    value="yes" 
                    label={t('journal.yes')}
                />
                <Radio 
                    value="no" 
                    label={t('journal.no')}
                />
            </Group>
        </Radio.Group>
    );
}; 